import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get targets() {
    return ["search", "option", "addTag", "newTagName"]
  }

  static get values() {
    return {
      upsertUrl: String,
      tagManagementUrl: String,
    }
  }

  search() {
    const searchValue = this.searchTarget.value.toLowerCase()
    let anySameName = false

    this.optionTargets.forEach((option) => {
      let optionName = option.dataset.name.toLowerCase()
      if (optionName === searchValue) {
        anySameName = true
      }

      if (optionName.includes(searchValue)) {
        option.classList.remove("d-none")
      } else {
        option.classList.add("d-none")
      }
    })

    if (searchValue !== "" && !anySameName) {
      this.addTagTarget.classList.remove("d-none")
      this.newTagNameTarget.textContent = this.searchTarget.value
    } else {
      this.addTagTarget.classList.add("d-none")
      this.newTagNameTarget.textContent = ""
    }
  }

  addTag() {
    if (this.addTagTarget.classList.contains("d-none")) {
      return
    }

    const formElement = TempFormHelper.create(this.upsertUrlValue, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "tag_name", this.searchTarget.value)
    })

    formElement.addEventListener("turbo:submit-end", () => {
      this.searchTarget.value = ""
      this.addTagTarget.classList.add("d-none")
      this.newTagNameTarget.textContent = ""
      this.optionTargets.forEach((option) => {
        option.classList.remove("d-none")
      })
    })

    formElement.requestSubmit()
  }

  updateTagging(event) {
    const httpMethod = event.target.checked ? "post" : "delete"
    const tagId = event.target.value
    const url = event.target.checked ? this.upsertUrlValue : `${this.upsertUrlValue}/${tagId}`
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    const formData = new FormData()
    formData.append("tag_id", tagId)

    fetch(url, {
      method: httpMethod,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token,
      },
      body: formData,
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error("Error updating tag:", error)
        event.target.checked = !event.target.checked
      })
  }

  updateTagColor(event) {
    TempFormHelper.create(`${this.tagManagementUrlValue}${event.target.dataset.id}`, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, "tag[color]", event.target.value)
    }).requestSubmit()
  }

  updateTagName(event) {
    TempFormHelper.create(`${this.tagManagementUrlValue}${event.target.dataset.id}`, "patch", (form) => {
      TempFormHelper.addHiddenInput(form, "tag[name]", event.target.value)
    }).requestSubmit()
  }
}
